<template>
  <div>
    <el-upload
    :http-request="httpRequest"
      :before-upload="beforeUpload"
      :show-file-list="false"
    >
      <img v-if="fileObj.link" :src="fileObj.link" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="isImagePreviewShow"
      :url-list="previewImgs"
      zIndex="3000"
      :on-close="closeImagePreview"
    ></el-image-viewer>
    <!-- 视频预览 -->
    <el-dialog
      :visible.sync="isVideoPreviewShow"
      custom-class="video-preview-dialog"
      append-to-body
      fullscreen
    >
      <div v-if="isVideoPreviewShow" class="video-preview">
        <video style="max-width: 100%; max-height: 100%;" :src="previewItem.link" controls></video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { putFile, downloadFile } from '@/api/crmedical/contract/add';
import website from '@/config/website';

export default {
  components: {
    ElImageViewer,
  },
  props: {
    fileObj:{
      
    },
    // 附件列表（至少要包含 link 属性）
    fileList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    // 需要支持的附件类型
    types: {
      type: Array,
      default: ['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png'],
    },
    // 附件类型的标识符 single-单一格式 multi-全格式
    typesFlag: {
      type: 'string',
      default: 'single',
    },
    // 是否可编辑
    disabled: {
      type: Boolean,
      default: false,
    },
    // 单个附件的最大存储空间
    max: {
      type: Number,
      default: website.maxUploadSize,
    },
    // 附件的最大个数
    limit: {
      type: Number,
      default: 3,
    },
    // 提示语
    message: {
      default: '',
    },
    // 提示语类型 pre-前置提示语 all-完全使用message
    messageType: {
      default: 'all',
    },
  },
  data() {
    return {
      isImagePreviewShow: false, // 是否显示图片预览
      isVideoPreviewShow: false, // 是否显示视频预览
      previewItem: {}, // 当前选中的预览对象
      previewImgs: [], // 待预览的图片列表
      limitDisabled: false, // 是否达到个数限制
    };
  },
  watch: {
    fileList() {
      let len = this.fileList.length;
      this.limitDisabled = len >= this.limit;
    },
  },
  methods: {
    // 获取文件类型
    getFileType(file) {
      let type = '';
      let ext = this.getFileExtension(file).toLocaleLowerCase();
      if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) {
        type = 'image';
      } else if (['mp4', 'mpeg4', 'webm'].includes(ext)) {
        type = 'video';
      } else if (['mp3', 'ogg'].includes(ext)) {
        type = 'audio';
      } else {
        type = 'other';
      }
      return type;
    },
    // 获取文件后缀
    getFileExtension(file) {
      let ext = '';
      if (file.originalName) {
        ext = file.originalName.split('.').pop();
      } else {
        ext = file.link.split('.').pop();
      }
      return ext;
    },
    // 文件预览
    handlePreview(file) {
      let type = this.getFileType(file);
      this.previewItem = file;
      if (type == 'image') {
        let arr = [];
        // 从数组里挑选出图片类型的方便切换上一张下一张
        if(this.getFileType(this.fileObj)== 'image'){
          arr =[this.fileObj]
        }
      
        // 从图片数组里提取图片url
        arr = arr.map((item) => {
          return item.link;
        });
        // 找到previewItem.link在数组里的位置
        let index = arr.findIndex((item) => {
          return item == this.previewItem.link;
        });
        // 将previewItem及后面的元素移到最前面去
        if (index > 0) {
          this.previewImgs = arr.slice(index).concat(arr.slice(0, index));
        } else {
          this.previewImgs = arr;
        }
        this.isImagePreviewShow = true;
      } else if (type == 'video' || type == 'audio') {
        this.isVideoPreviewShow = true;
      }
    },
    // 关闭图片预览
    closeImagePreview() {
      this.isImagePreviewShow = false;
    },
    //同步数据到父组件
    update() {
      this.fileObj.status =1
     
    

      this.limitDisabled = this.fileList.link==""?false:true;

      this.$emit('update:fileObj', this.fileObj);
      this.$emit('uploadCallBack', this.fileObj);
    },
    beforeUpload(file) {
      // 判断文件格式
      if (this.typesFlag == 'multi') {
        let flag = false;
        let fileType = file.type;
        this.types.forEach((ele) => {
          if (ele == fileType) {
            flag = true;
          }
        });
        if (!flag) {
          this.$message.warning('请上传正确格式文件');
          return false;
        }
      } else {
        let extension = file.name.split('.').pop();
        if (!this.types.includes(extension.toLocaleLowerCase())) {
          this.$message.warning('仅支持' + this.types.toString() + '文件格式');
          return false;
        }
      }
      // 判断个数
      if (this.limitDisabled) {
        return false;
      }
      // 判断大小
      if (file.size > this.max) {
        // this.putFile = Object.assign({}, this.fileList);
        this.$message.error(`文件不能大于${this.max / (1024 * 1024)}MB`);
        return false;
      }
    },
    //上传方法
    httpRequest(file) {
      let fd = new FormData();
      fd.append('file', file.file);
      putFile(fd, { timeout: 120000 })
        .then((res) => {
          res.data.uid = file.file.uid;
          if (res.success) {
            //处理一个bug
            if (!res.data['id'] && res.data['attachId']) {
              res.data['id'] = res.data['attachId'];
            }
            this.fileObj = res.data
            // this.fileList.push(res.data);
            this.update();
          }
        })
        .catch((err) => {});
    },
    //移除
    handleRemove(file) {
      let deleteIndex;
      this.fileObj ={}
      // this.fileList.forEach((item, index) => {
      //   if (item == file) {
      //     deleteIndex = index;
      //   }
      // });
      // if (deleteIndex !== undefined) {
      //   this.fileList.splice(deleteIndex, 1);
      // }
      this.update();
    },
    //下载方法
    handleDownload(file) {
      downloadFile(file.link, file.originalName);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-preview {
  width: 100vw;
  height: calc(100vh - 30px);
  display: flex;
  justify-content: center;
}
::v-deep .video-preview-dialog {
  background-color: rgba(0, 0, 0, 0.5) !important;
  div {
    padding: 0 !important;
  }
  .el-dialog__header {
    height: 30px;
  }
}
</style>
